import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import WaivePrepaymentFeeModalUI from './WaivePrepaymentFeeModalUI.js'

class WaivePrepaymentFeeModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      waivePrepaymentFee: this.props.loan.waivePrepaymentFee ? 'true' : 'false',
      waivePrepaymentError: null
    }
  }

  render() {
    let booleanList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]
    return (
      <WaivePrepaymentFeeModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        waivePrepaymentFee={this.state.waivePrepaymentFee}
        onWaivePrepaymentChange={(event) => { this.setState({ waivePrepaymentFee: event.target.value }) }}
        waivePrepaymentError={this.state.waivePrepaymentError}
        booleanList={booleanList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/prepayments/fees/waiver`,
      this.onSubmitCallback,
      {
        waivePrepaymentFee: this.state.waivePrepaymentFee
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(WaivePrepaymentFeeModalSF)
